import script from "./RegistrationAIResumeUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationAIResumeUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationAIResumeUploadModal.vue?vue&type=style&index=0&id=3a4a78d7&scoped=true&lang=css"
import "./RegistrationAIResumeUploadModal.vue?vue&type=style&index=1&id=3a4a78d7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4a78d7"]])

export default __exports__